class showVatMode {
  constructor() {
    this.showVat = true;

    // overwrite the showVAT local storage item on load when the user has the URL param include_vat (this is set in the Country popup)
    const currentUrl = new URL(window.location.href);
    const currentUrlParams = new URLSearchParams(currentUrl.search);
    if (currentUrlParams.has('include_vat', 'false')) {
      localStorage.setItem('showVat', false);
    } else if (currentUrlParams.has('include_vat', 'true')) {
      localStorage.setItem('showVat', true);
    }

    this.checkVat();
    this.init();
  }

  checkVat = () => {
    if (localStorage.getItem('showVat')) {
      this.showVat = JSON.parse(localStorage.getItem('showVat'));
    }

    // Update the VAT status indicators (if any)
    const elemOn = document.querySelector('[data-vat-status-on]');
    const elemOff = document.querySelector('[data-vat-status-off]');
    if (elemOn && elemOff) {
      elemOn.classList.toggle('text-primary', this.showVat);
      elemOn.classList.toggle('text-primary-300', !this.showVat);
      elemOff.classList.toggle('text-primary', !this.showVat);
      elemOff.classList.toggle('text-primary-300', this.showVat);
    }

    // Toggle visibility of VAT messages
    document.querySelectorAll('[data-price-toggle-vat]').forEach((containerElem) => {
      const elemIncVat = containerElem.querySelectorAll('[data-price-vat-included]');
      const elemExcVat = containerElem.querySelectorAll('[data-price-vat-excluded]');

      elemIncVat.forEach((elem) => elem.toggleAttribute('hidden', !this.showVat));
      elemExcVat.forEach((elem) => elem.toggleAttribute('hidden', this.showVat));
    });

    // Update all VAT toggle inputs to match current state
    document.querySelectorAll('[name="showVat"]').forEach((elem) => (elem.checked = this.showVat));
  };

  init = () => {
    // Handle checkbox inputs
    document.querySelectorAll('[name="showVat"]').forEach((elem) => {
      elem.checked = this.showVat;

      elem.addEventListener('change', ({ target: { checked } }) => {
        // Update localStorage and all other toggles when any toggle changes
        localStorage.setItem('showVat', checked);
        this.showVat = checked;
        this.checkVat();
      });
    });

    // Handle clicks on price toggle vat spans
    document.querySelectorAll('[data-toggle-vat]').forEach((elem) => {
      elem.addEventListener('click', () => {
        localStorage.setItem('showVat', !this.showVat);
        this.checkVat();
      });
    });

    // Observe the body for changes
    const vatObserver = new MutationObserver(() => this.checkVat());
    vatObserver.observe(document.querySelector('body'), {
      attributes: false,
      childList: true,
      subtree: true,
    });
  };
}

const showVatInit = new showVatMode();
